import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
import { CountUp } from 'countup.js';
import btnAnimate from '../../text-animations/btn';
import { SplitText } from '../../vendor/gsap/SplitText';
import { ScrollSmoother } from '../../vendor/gsap/ScrollSmoother';
import smoov from '../../util/smooth-scroll';
import '../../util/form-label';

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, ScrollToPlugin);
smoov();
// Animated number countup function for the stats block
function runNum(elem) {
    if ($(elem).hasClass('activated')) {
        return false;
    }
    const dataNum = $(elem).attr('data-num');
    const thisId = $(elem).attr('id');
    const statNum = new CountUp(`${thisId}`, dataNum, {
        decimal: ',',
    });

    if (!statNum.error) {
        $(elem).addClass('activated');
        statNum.start();
    } else {
        console.error(statNum.error);
    }
    return false;
}

if ($('body').hasClass('landing-detail')) {
    // Quoteblock turbo lines (above and below quote)
    const quoteBlocks = gsap.utils.toArray('.quote-trigger');

    quoteBlocks.forEach((item) => {
        const line = $(item).find('.turbo-line-stretch');
        gsap.to(line, {
            scaleX: 1,
            scrollTrigger: {
                trigger: item,
                start: 'top 80%',
                scrub: true,
                end: 'top 10%',
            },
        });
    });

    const blocks = document.querySelectorAll('.stats-item');

    blocks.forEach((block) => {
        const num = $(block).find('.anim-number');
        const blockTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.animated-stats-block',
                start: 'top 85%',
                end: 'bottom top',
                toggleActions: 'play none none none',
                onEnter: () => { runNum(num); },
            },
        })
            // Animate the header items
            .from(block.querySelectorAll('.stat-hdr'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            });

        // Animate the content items
        const items = block.querySelectorAll('.stat-body');
        blockTimeline.from(items, {
            duration: 1,
            x: 40,
            opacity: 0,
            stagger: 0.25,
        }, 0);

        // Animate the ps in the items
        items.forEach((item, i) => {
            blockTimeline.from(item.querySelectorAll('p'), {
                duration: 1,
                opacity: 0,
                stagger: 0.25,
            }, i * 0.25);
        });
    });

    $('[loading="lazy"]').each((e, i) => {
        const thisImg = i;

        thisImg.addEventListener('load', () => {
            // Refresh scrolltriggers after layout shift
            window.dispatchEvent(new Event('resize'));
        });
    });
}

// For sharing posts or individual page(s)
// Get content of meta tags for .js-share-link click function
const metaUrl = document.querySelectorAll("[property='og:url']")[0];
const articleTitle = encodeURIComponent($("[property='og:title']").attr('content'));
const articleUrl = encodeURIComponent(metaUrl.getAttribute('content'));
const metaDesc = document.querySelectorAll("[property='og:description']")[0];
const shareLink = document.querySelectorAll('.js-share-link');

if (shareLink.length) {
    const articleDesc = encodeURIComponent(metaDesc.getAttribute('content'));

    // Build urls for Facebook Twitter LinkedIn & Email
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${articleUrl}`;
    const twitterUrl = `https://twitter.com/share?text=${articleDesc}&url=${articleUrl}`;
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${articleUrl}`;
    const emailUrl = `mailto:?subject=Core%20Health%20Insights%20|%20${articleTitle}&body=${articleDesc}%0D%0A%0D%0ARead%20the%20full%20article%20here:%20${articleUrl}`;

    // Listen to all .js-share-link clicks on the document
    const shareDialog = (el) => {
        const attribute = el.currentTarget.getAttribute('data-platform');
        el.preventDefault();

        switch (attribute) {
            case 'facebook':
                window.open(facebookUrl, 'facebookwindow', 'width=800, height=500');
                break;
            case '𝕏':
                window.open(twitterUrl, 'twitterwindow', 'width=800, height=500');
                break;
            case 'linkedin':
                window.open(linkedinUrl, 'linkedinwindow', 'width=600, height=500');
                break;
            case 'email':
                window.location.href = emailUrl;
                break;
            default:
                break;
        }
    };

    shareLink.forEach((e) => {
        e.addEventListener('click', shareDialog);
    });
}

if ($('body').hasClass('news-detail')) {
    $('.social-share-links').on('mouseenter', () => {
        $('.social-share-links').addClass('activated');
    });
}

// Index page

// For after dom loaded
function checkForBtn() {
    $('.js-btn-split').each((e, index) => {
        btnAnimate(index);
    });

    $('.link:not(.dropdown-item):not(.footer-link):not(.privacy-policy)').each((e, index) => {
        btnAnimate(index);
    });
}

if ($('body').hasClass('news-index')) {
    document.body.addEventListener('htmx:afterSettle', (evt) => {
        // evt.preventDefault();
        checkForBtn();
    });
}

document.body.addEventListener('htmx:afterSwap', () => {
    console.log('did this trigger on the submit?');

    const thankYouMsg = document.getElementById('newsletter-signup');
    if (thankYouMsg) {
        const preIcon = $('.pre-send-icon');
        const sentIcon = $('#send-icon');
        $(preIcon).addClass('d-none');
        $(sentIcon).removeClass('d-none');


        // $(preIcon).replaceWith(sentIcon);
        // $('.pre-send-icon').css('display', 'none');
        // console.log('function to animate envelope');
    }

    const moreNewsElement = document.getElementById('js-more-news');
    if (!moreNewsElement) {
        const newsContainer = document.getElementById('card-grid');

        if (newsContainer) {
            newsContainer.classList.remove('load-more-padding-bottom');
        }
    }
});
